import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Category from '@mui/icons-material/Category';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Snackbar from '@mui/material/Snackbar';
import InputAdornment from '@mui/material/InputAdornment';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import Stepper from '../components/Stepper';
import Progress from '../components/Loader';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 550,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function BasicModal() {
  const [open, setOpen] = React.useState(false);
  const [loading, setloading] = React.useState(false);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const Food = [
    { value: "Cereals" },
    { value: "Industrial crops" },
    { value: "Legumes" },
    { value: "Fruits" },
    { value: "Vegetables" },
    { value: "Starchy" },
    { value: "tuber" },
    { value: "root crops" }
  ];

  const clearForm = () => {
    document.getElementById("discountname").value = "";
    document.getElementById("percentage").value = "";
    document.getElementById("description").value = "";
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbarOpen(false);
  };

  const addproduct = () => {
    setloading(true);
    const doer = async () => {
      try {
        const res = await axios.post("https://embert.sisrevolution.com/api/discount/", {
          discountname: document.getElementById("discountname").value,
          percentage: document.getElementById("percentage").value,
          description: document.getElementById("description").value,
        });
        if (res.status === 200) {
          setloading(false);
          setSnackbarMessage('Discount added successfully!');
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          clearForm();
          handleClose();
        } else {
          setloading(false);
          setSnackbarMessage('Failed to add discount.');
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        }
      } catch (err) {
        setloading(false);
        setSnackbarMessage('An error occurred while adding discount.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      }
    };
    doer();
  };

  return (
    <div>
      <Button variant="outlined" startIcon={<Category />} onClick={handleOpen}>
        Add New Process
      </Button>
      <Dialog fullWidth maxWidth="lg" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Add new Process
          <IconButton onClick={handleClose} style={{ float: "right" }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box
            component="form"
            sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
            noValidate
            autoComplete="off"
          >
            <TextField
              id="discountname"
              label="Discount Name"
              type="text"
              autoComplete="current-text"
            />
            <TextField
              id="percentage"
              label="Discount Percentage"
              type="number"
              autoComplete="current-text"
              InputProps={{
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
              }}
            />
            <TextField
              id="description"
              label="Description"
              multiline
              rows={4}
            />
            <Stepper />
          </Box>
          <br />
        </DialogContent>
        <Divider />
        <DialogActions>
          <div style={{ marginTop: 2, textAlign: "center", width: "100%" }}>
            {loading ? (
              <Button variant="outlined" startIcon={<Progress />} disabled>
                Loading...
              </Button>
            ) : (
              <Button variant="outlined" startIcon={<Category />} size="large" onClick={addproduct}>
                Submit New Process
              </Button>
            )}
          </div>
        </DialogActions>
      </Dialog>
      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}